import React, { useEffect, useState } from "react";
import MangeDashboard from "./ManageDashboard";
import Select, { components } from "react-select";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import AfterLoginNav from "../AfterLoginNav";
import {
  depositRequest,
  getBankAccounts,
  sendTransactionRequest,
} from "../../services/bank";
import { getSystemParameters } from "../../services/cms";

export default function Deposit({ flag = false }) {
  const [cardChoose, setCardChoose] = useState("");
  const { SingleValue, Option } = components;
  const [cards, setCards] = useState([]);
  const [maxTransaction, setMaxTransaction] = useState(0);
  const [amount, setamount] = useState(0);
  const [rulAccept, setRulAccept] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  function handlechecked(cb) {
    setRulAccept(rulAccept ? false : true);
  }

  useEffect(() => {}, [rulAccept]);
  const customStylesSelect = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#f4de8b",
      borderRadius: 10,
      width: "100%",
      height: 60,
      border: "none",
      paddingLeft: 10,
      paddingRight: 10,
      boxSizing: "border-box",
      color: "#000",
    }),

    option: (provided, { isFocused, isSelected }) => ({
      ...provided,
      background: isFocused ? "#eaeaea" : isSelected ? "#fff" : undefined,

      zIndex: 1,
      color: isSelected ? "#000" : "#707070",
    }),
    singleValue: (provided) => ({
      ...provided,
    }),
  };

  const onchangeSelect = (item) => {
    setCardChoose(item);
  };

  const IconSingleValue2 = (props) => (
    <SingleValue {...props}>
      <span className={"text-large pl-1"}>{props.data.label}</span>
      <span className={"text-medium text-price pl-2"}>{props.data.value}</span>
    </SingleValue>
  );

  const IconOption2 = (props) => (
    <Option {...props}>
      <span className={"text-large pl-1"}>{props.data.label}</span>
      <span className={"text-medium text-price pl-2"}>{props.data.value}</span>
    </Option>
  );

  useEffect(() => {
    function fetchData() {
      getSystemParameters().then((res) => {
        if (res.status === 200) {
          const data = res?.data?.results;
          for (let d of data) {
            if (d.key === "max_bank_transaction_amount") {
              setMaxTransaction(d.value);
            }
          }
        }
      });
      getBankAccounts().then((res) => {
        if (res.status == 200) {
          let option = res?.data?.results || [];
          let cardd = option.map((opt) => {
            return {
              value: opt.card_number,
              lable: opt.id,
              default: opt.default,
            };
          });
          setCards(cardd);
          for (let card of cardd) {
            if (card.default) {
              setCardChoose(card);
            }
          }
        }
      });
    }
    fetchData();
  }, []);

  function separateNum(event) {
    let value = event.target.value;
    var nStr = value + "";
    nStr = nStr.replace(/\,/g, "");
    let x = nStr.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    if (event !== undefined) {
      event.target.value = x1 + x2;
      ex_normalNum(event.target.value);
    } else {
      return x1 + x2;
    }
  }

  function ex_normalNum(num) {
    num = num.replace(/,\s?/g, "");
    setamount(num);
  }

  async function handleSubmit() {
    if (!cardChoose) {
      toast.error("لطفا کارت مدنظر خود را انتخاب کنید");
      return;
    }

    if (!amount) {
      toast.error("لطفا مبلغ مورد نظر را وارد نمایید ");
      return;
    }

    setIsLoading(true);
    depositRequest(amount, cardChoose.lable)
      .then((res) => {
        const data = res?.data?.data;
        sendTransactionRequest(data?.invoice_key)
          .then((res) => {
            setIsLoading(false);
            if (res.status == 201) {
              if (res?.data?.data?.gateway_url) {
                window.location.href = res?.data?.data?.gateway_url;
              }
            } else {
              toast.error(res.data.detail);
            }
          })
          .catch((error) => {
            setIsLoading(false);
          });
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  return (
    <>
      {flag ? (
        <div>
          <form>
            <div className="w-100 pt-2 pb-2 index-for-select">
              <span className="d-flex pe-2 pb-1 lable5050">شماره کارت</span>

              <Select
                styles={customStylesSelect}
                components={{
                  SingleValue: IconSingleValue2,
                  Option: IconOption2,
                }}
                options={cards}
                onChange={onchangeSelect}
                value={cardChoose}
              />
            </div>

            <div className="liadd66">
              <Link to={"/addcard"} className={"stLink"}>
                <span className="add-card-plus">
                  افزودن کارت جدید
                  <img src={"/images/svg/add-card-plus.svg"} alt={""} />
                </span>
              </Link>
            </div>

            <div className="w-100 pt-2 pb-2 pos-rel margin-for-varizi">
              <span className="d-flex pe-2 pb-1 lable5050">مبلغ واریزی</span>
              <input
                type="tel"
                name="codemeli"
                id={"codemeli"}
                className="form-input-custom"
                onKeyUp={separateNum}
              />
            </div>

            <div className="cfvv  ">
              <input
                type="checkbox"
                id="vehicle1"
                name="vehicle1"
                value="Bike"
                className="ml-3"
                onClick={handlechecked}
              />
              <div className="d-flex tit5060">
                اینجانب تمام{" "}
                <Link to={"/info?state=ruls"} className="kjfsfewrulesss">
                  قوانین
                </Link>{" "}
                طلایی شو را می پذیریم.
              </div>
              <br />
            </div>

            <div className="w-100 pt-2 pb-2">
              <button
                className="form-input-button-custom"
                type="button"
                onClick={handleSubmit}
                disabled={rulAccept}
              >
                {isLoading ? (
                  <img src={"./loading.svg"} alt={""} className={"w-loading"} />
                ) : (
                  <>پرداخت از طریق درگاه بانکی</>
                )}
              </button>
            </div>
          </form>

          <div className="box-center5050 mt5050 mp-0">
            <div className="items-for-bottom-deposit">
              <img
                src="images/svg/warning-red.svg"
                alt=""
                className="image-padding-left-deposit"
              />
              در هر ۲۴ ساعت می‌توانید به ازای هر کارت بانکی موجودی خود را تا{" "}
              {new Intl.NumberFormat("fa", {
                maximumFractionDigits: 0,
              }).format(maxTransaction)}{" "}
              تومان افزایش دهید. برای افزایش بیش از
              {new Intl.NumberFormat("fa", {
                maximumFractionDigits: 0,
              }).format(maxTransaction)}{" "}
              تومان از طریق واریز شناسه دار، تماس بگیرید. (۱۹ ۲۴ ۶۹ ۹۱ ۰۲۱)
            </div>
          </div>
        </div>
      ) : (
        <MangeDashboard>
          <AfterLoginNav title={"افزایش موجودی"} hasBack={() => navigate(-1)} />
          <div className="content-deposit-container">
            <div className="authincation section-padding">
              <div className="container h-100">
                <div className="row justify-content-center h-100 align-items-center">
                  <div className="col-xl-8 col-md-8">
                    <div className="mini-logo text-center my-2"></div>
                    <div className="auth-form  custom-shadow">
                      <div>
                        <form>
                          <div className="w-100 pt-2 pb-2 index-for-select">
                            <span className="d-flex pe-2 pb-1 lable5050">
                              شماره کارت
                            </span>

                            <Select
                              styles={customStylesSelect}
                              components={{
                                SingleValue: IconSingleValue2,
                                Option: IconOption2,
                              }}
                              options={cards}
                              onChange={onchangeSelect}
                              value={cardChoose}
                            />
                          </div>

                          <div className="liadd66">
                            <Link to={"/addcard"} className={"stLink"}>
                              <span className="add-card-plus">
                                افزودن کارت جدید
                                <img
                                  src={"/images/svg/add-card-plus.svg"}
                                  alt={""}
                                />
                              </span>
                            </Link>
                          </div>

                          <div className="w-100 pt-2 pb-2 pos-rel  margin-for-varizi">
                            <span className="d-flex pe-2 pb-1 lable5050">
                              مبلغ واریزی
                            </span>
                            <input
                              name="codemeli"
                              id={"codemeli"}
                              className="form-input-custom d"
                              onKeyUp={separateNum}
                            />
                          </div>

                          <div className="cfvv">
                            <input
                              type="checkbox"
                              id="vehicle1"
                              name="vehicle1"
                              value="Bike"
                              className="ml-3"
                              onClick={handlechecked}
                            />
                            <div className="d-flex tit5060">
                              اینجانب تمام{" "}
                              <Link
                                to={"/info?state=ruls"}
                                className="kjfsfewrulesss"
                              >
                                قوانین
                              </Link>{" "}
                              طلایی شو را می پذیریم.
                            </div>
                            <br />
                          </div>

                          <div className="w-100 pt-2 pb-2">
                            <button
                              className="form-input-button-custom"
                              type="button"
                              onClick={handleSubmit}
                              disabled={rulAccept}
                            >
                              {isLoading ? (
                                <img
                                  src={"./loading.svg"}
                                  alt={""}
                                  className={"w-loading"}
                                />
                              ) : (
                                <>پرداخت از طریق درگاه بانکی</>
                              )}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row justify-content-center h-100 align-items-center">
              <div className="col-xl-8 col-md-8">
                <div className="items-for-bottom-deposit">
                  <img
                    src="images/svg/warning-red.svg"
                    alt=""
                    className="image-padding-left-deposit"
                  />
                  در هر ۲۴ ساعت می‌توانید به ازای هر کارت بانکی موجودی خود را تا
                  {new Intl.NumberFormat("fa", {
                    maximumFractionDigits: 0,
                  }).format(maxTransaction)}{" "}
                  تومان افزایش دهید. برای افزایش بیش از{" "}
                  {new Intl.NumberFormat("fa", {
                    maximumFractionDigits: 0,
                  }).format(maxTransaction)}{" "}
                  از طریق واریز شناسه دار، تماس بگیرید. (۱۹ ۲۴ ۶۹ ۹۱ ۰۲۱)
                </div>
              </div>
            </div>
          </div>
        </MangeDashboard>
      )}
    </>
  );
}
